import { Box } from "@mui/material";

type WorkspaceAvatarProps = {
  alt: string;
  src: string;
};

export const WorkspaceAvatar = ({ alt, src }: WorkspaceAvatarProps) => (
  <Box
    alt={alt}
    component="img"
    src={src}
    sx={{ borderRadius: "50%", height: 24, width: 24 }}
  />
);
